
import _ from 'lodash';
// `action` is aliased so the imported MobX annotation does not collide with
// the `action` constructor parameter used below.
import { observable, action as mobxAction } from 'mobx';
import { ModalParams } from 'core/models';
import { toDate } from 'core/utils';

class TaskNotificationsStore {
    
    @observable accessor call = null;
    @observable accessor disableCheckboxes = false;
    constructor(rootStore,action) {

        this.rootStore = rootStore;
        this.call = action.fetchFunc;
        this.action = action;

        this.taskNotificationsModal = new ModalParams({onClose:() => this.callFunc()});
    }

    @mobxAction.bound
    async fetchFunc(fetchFunc) {
        const response = await fetchFunc(); 
        const notifications = _.map(response.data.item, (item) => {
            const facilityScheduleDate = item && item.facilityScheduleDate;
            const areaOfCareName = facilityScheduleDate.areaOfCare ? `/${facilityScheduleDate.areaOfCare.name}`: ``;

            return _.extend(item, {
                facilityScheduleDate: facilityScheduleDate,
                taskName: `${facilityScheduleDate.facility && facilityScheduleDate.facility.name}${areaOfCareName}, ${toDate(facilityScheduleDate.date)}`
            }); 
        });
        const grouped = _.groupBy(notifications, 'facilityScheduleDateId');
        return grouped;
    }

    @mobxAction.bound
    async callFunc() {
        this.fetchFunc(this.call).then(v => {this.rootStore.viewStore.taskNotifications = v});
    }

    @mobxAction.bound
    async onOpenNotifications(items) {
        this.taskNotificationsModal.open({ 
            item: items
        });
    }
}

export default TaskNotificationsStore;
